var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNomsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ph:note-thin",
    clipPath: "url(#clip0_3651_62176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3651_62176",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: 0,
    width: 65,
    height: 61
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 2375",
    d: "M60.75 44.5C60.75 46.1 35.5833 21.9995 21.25 6.99946L7.75 8L60.75 61H-3.25V2.49946C-3.25 -1.10054 39.4167 0.999465 60.75 2.49946V44.5Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3651_62176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.125 34.0156H35.25H41.375C41.6444 34.0156 41.9027 33.9086 42.0932 33.7182C42.2836 33.5277 42.3906 33.2694 42.3906 33C42.3906 32.7306 42.2836 32.4723 42.0932 32.2818C41.9027 32.0914 41.6444 31.9844 41.375 31.9844H33.25H25.125C24.8556 31.9844 24.5973 32.0914 24.4068 32.2818C24.2164 32.4723 24.1094 32.7306 24.1094 33C24.1094 33.2694 24.2164 33.5277 24.4068 33.7182C24.5973 33.9086 24.8556 34.0156 25.125 34.0156ZM33.25 40.1094H25.125C24.8556 40.1094 24.5973 40.2164 24.4068 40.4068C24.2164 40.5973 24.1094 40.8556 24.1094 41.125C24.1094 41.3944 24.2164 41.6527 24.4068 41.8432C24.5973 42.0336 24.8556 42.1406 25.125 42.1406H33.25C33.5194 42.1406 33.7777 42.0336 33.9682 41.8432C34.1586 41.6527 34.2656 41.3944 34.2656 41.125C34.2656 40.8556 34.1586 40.5973 33.9682 40.4068C33.7777 40.2164 33.5194 40.1094 33.25 40.1094ZM56.6094 12.6875V40.2846C56.6104 40.6848 56.5319 41.0812 56.3785 41.4508C56.2251 41.8204 55.9998 42.1559 55.7156 42.4377L49.2017 48.9529L42.6877 55.4682C42.4054 55.7515 42.0698 55.9761 41.7003 56.1291C41.3307 56.2821 40.9345 56.3603 40.5346 56.3594H12.9375C12.1294 56.3594 11.3544 56.0384 10.783 55.467C10.2116 54.8956 9.89062 54.1206 9.89062 53.3125V12.6875C9.89062 11.8794 10.2116 11.1044 10.783 10.533C11.3544 9.96163 12.1294 9.64063 12.9375 9.64062H19.75H53.5625C54.3706 9.64062 55.1456 9.96163 55.717 10.533C56.2884 11.1044 56.6094 11.8794 56.6094 12.6875ZM12.9375 54.3281H40.3594V41.125C40.3594 40.8556 40.4664 40.5973 40.6568 40.4068C40.8473 40.2164 41.1056 40.1094 41.375 40.1094H54.5781V12.6875C54.5781 12.4181 54.4711 12.1598 54.2807 11.9693C54.0902 11.7789 53.8319 11.6719 53.5625 11.6719H12.9375C12.6681 11.6719 12.4098 11.7789 12.2193 11.9693C12.0289 12.1598 11.9219 12.4181 11.9219 12.6875V53.3125C11.9219 53.5819 12.0289 53.8402 12.2193 54.0307C12.4098 54.2211 12.6681 54.3281 12.9375 54.3281ZM53.1436 42.1406H42.3906V52.8936L47.7671 47.5171L53.1436 42.1406Z",
    fill: "#8F91A1"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.125 8.625L56.875 57.375",
    stroke: "#8F91A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3651_62176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white",
    transform: "translate(0.75 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNomsg);
export default __webpack_public_path__ + "static/media/nomsg.63a8cd6572a39d48d7631232ff4141d4.svg";
export { ForwardRef as ReactComponent };